import type { ReactNode } from 'react';
import { styled } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DataIdWrapper = styled.div<{
	children?: ReactNode;
	['data-test-id']: string;
}>({});
